import TableArea, { DEFAULT_TABLE_AREA } from "../models/TableArea";

export const getAllLocationTableAreasRefs = (tableAreas: TableArea[] | undefined): string[] => {

    if (tableAreas) {
        return [DEFAULT_TABLE_AREA.ref, ...tableAreas.map(area => area.ref)];
    }

    return [DEFAULT_TABLE_AREA.ref]
}